import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { DateTime } from "@common/data-models/complex-types/date-time";
import { ObjectTypes } from "@common/enums/object-types";

export class StoryRecord extends Record {
    constructor() {
        super();
        this.type = ObjectTypes.SCRIPT;
    }

    public initialize() {
        this.type = ObjectTypes.SCRIPT;
        super.initialize();

        this.setupRequiredFieldsGroups("Script");
    }

    public static get titleSeparator(): string {
        return Record.visualStateService.ConfigSettings["TitleSeparator"] ? Record.visualStateService.ConfigSettings["TitleSeparator"] : "-";
    }

    private _storySlug: string = null;
    private _segment: string = null;
    private _recalculateStorySlugAndSegment() {
        let separatorPosition = this.title.indexOf(StoryRecord.titleSeparator);
        if (separatorPosition >= 0) {
            this._storySlug = this.title.substr(0, separatorPosition).trim();
            this._segment = this.title.substr(separatorPosition + 1, this.title.length - 1).trim();
        } else {
            this._storySlug = this.title;
            this._segment = " ";
        }
    }

    private _oldTitle: string = null;
    public get storySlug(): string {
        if (this._oldTitle != this.title) {
            this._recalculateStorySlugAndSegment();
            this._oldTitle = this.title;
        }
        return this._storySlug;
    }

    // renamed from segment to Segment
    public get Segment(): string {
        if (this._oldTitle != this.title) {
            this._recalculateStorySlugAndSegment();
            this._oldTitle = this.title;
        }
        return this._segment;
    }

    public get text(): string { return this.getAs<string>(PSTFieldNames.PSTRichText); }
    public set text(value: string) { this.set(PSTFieldNames.PSTRichText, value); }

    public get locked(): boolean { return this.getAs<boolean>(PSTFieldNames.PSTStoryLocked); }
    public set locked(value: boolean) { this.set(PSTFieldNames.PSTStoryLocked, value); }
}
